
import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FaArrowCircleLeft, FaTrash, FaPlusCircle, } from "react-icons/fa";

import axios from "axios";
import { FaSearch } from "react-icons/fa";
import { showSuccess, showError, showWarning } from "../../General/Toast";
import { useMemo } from "react";
import { toast } from "react-toastify";

function AddSale({ clientData, role }) {

  const navigate = useNavigate();
  const location = useLocation();
  const editData = location.state;
  const isEditFromSaleHistory =
  location.state?.editMode === true &&
  location.state?.fromSaleHistory === true;

  const [ReturnDate, setReturnDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [openItemDropdown, setOpenItemDropdown] = useState(null);
const [itemSearch, setItemSearch] = useState("");
  const [partyName, setPartyName] = useState("");
  const [partyAddress, setPartyAddress] = useState("");
  const [partyGst, setPartyGst] = useState("");
  const [partyNo, setPartyNo] = useState("");
  const [purchaseBill, setPurchaseBill] = useState([]);
  const [returnAgainst, setReturnAgainst] = useState("");
const [received, setReceived] = useState(0);
  const [due, setDue] = useState(0);
  const [unit, setunit] = useState([]);
  const [category, setCategory] = useState([]);
  const [visitParty, setVisitParty] = useState(0);
  const [originalTotalPur, setOriginalTotalPur] = useState(0);
  const [previousBalance, setPreviousBalance] = useState(0);
  const [isIGSTBill, setIsIGSTBill] = useState(false);
  const [estimateDate, setEstimateDate] = useState(
    new Date().toISOString().slice(0, 16)
  );
  const [estimateNo, setEstimateNo] = useState("");
  const [inventory, setInventory] = useState([]);
  const [description, setDescription] = useState("");
  const [selectedBankId, setSelectedBankId] = useState(0);
  const [bankList, setBankList] = useState([]);
  const [paidAmount, setPaidAmount] = useState(0);
  const [isFullyPaid, setIsFullyPaid] = useState(false);
  const [discountValue, setDiscountValue] = useState(0);
  const [discountTypeUI, setDiscountTypeUI] = useState("amount");
  const [invoiceNo, setInvoiceNo] = useState("");
  const [selectedParty, setSelectedParty] = useState(null);
  const [showPartyModal, setShowPartyModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [partyList, setPartyList] = useState([]);
  const [search, setSearch] = useState("");
 const [showExitModal, setShowExitModal] = useState(false);
  const [isNewParty, setIsNewParty] = useState(false);
  const [showPartyForm, setShowPartyForm] = useState(false);
  const [newCust, setNewCust] = useState({
    name: '',
    first_visit: '',
    last_visit: '',
    mobile: '',
    email: "",
    total_pur: "",
    total_due: "",
    loyality: '',
    visits: "",
    gstin: '',
    gst_type: "",
    gst_state: '',
    address: '',
    history: '',
    opening_balance: '',
    opening_bal_status: '',
    balance: '',
    asOfDate: '',
    p_type: '',
    client_id: '',
    invoiceNo: '',
    payment_method: ''
  })

  const [formData, setFormData] = useState({
    payment_method: '',
    client_id: '',
    description: '',
    date: '',
    mode: '',
    cb_payid: '',
    paid: '',
    client_type: '',
    category: "",
    seller_name: "",
  });
  const isEditMode = Boolean(editData);
  const currId = editData?.id || 0 ;

  useEffect(() => {
    if (!editData) return;

    setSelectedParty({
      id: editData.party_id,
      name: editData.name,
      mobile: editData.mobile,
      address: editData.address,
      gstin: editData.gstin,
    });

    setInvoiceNo(editData.invoiceNo || "");
    setPartyName(editData.name || "");
    setPartyAddress(editData.address || "");
    setPartyNo(editData.mobile || "");
    setDescription(editData.description || "");
    setEstimateDate(
      editData.date || "",
    );

    setBillDiscount({
      type:
        editData.last_discount_type === "Percentage"
          ? "percent"
          : "amount",
      value: Number(editData.last_discount || 0),
    });

    // const parsed =
    //   typeof editData.items === "string"
    //     ? JSON.parse(editData.items)
    //     : editData.items;

    // const formattedRows = parsed.map((item, index) => ({
    //   id: index + 1,
    //   name: item.name,
    //   category: item.category,
    //   unit: item.unit,
    //   qty: Number(item.quant),
    //   price: Number(item.price_per_unit),
    //   discountType: item.dis_type || "percent",
    //   discountValue: Number(item.discount || 0),
    //   taxRate: item.taxRate || "",
    //   taxType: item.sale_price_withTax || "Without Tax",
    //   amount: Number(item.amount),
    // }));

    let parsed = [];

try {
  if (typeof editData.items === "string") {
    parsed = JSON.parse(editData.items);
  } else {
    parsed = editData.items;
  }

  // Make sure parsed is an array
  if (!Array.isArray(parsed)) {
    console.error("editData.items is not an array:", parsed);
    parsed = [];
  }
} catch (error) {
  console.error("Error parsing editData.items:", error);
  parsed = [];
}

const formattedRows = parsed.map((item, index) => ({
  id: index + 1,
  name: item.name || "",
  category: item.category || "",
  unit: item.unit || "",
  qty: Number(item.quant || 0),
  price: Number(item.price_per_unit || 0),
  discountType: item.dis_type || "percent",
  discountValue: Number(item.discount || 0),
  taxRate: item.taxRate || "",
  taxType: item.sale_price_withTax || "Without Tax",
  amount: Number(item.amount || 0),
}));

    setRows(formattedRows);

    setFormData((prev) => ({
      ...prev,
      payment_method: editData.payment_method || "",
      seller_name: editData.seller || '',
    }));

    setSelectedBankId(Number(editData.cb_payid || 0));

    setPaidAmount(Number(editData.received || 0));


  }, [editData]);




  const [billDiscount, setBillDiscount] = useState({
    type: "percent",
    value: 0,
  });

  const [rows, setRows] = useState([
    {
      id: 1,
      name: "",
      category: "",
      unit: "",
      price: "",
      qty: "",
      taxType: "Without Tax",
      taxRate: "",
      amount: "",
      discountType: "percent",
      discountValue: 0,
    },
  ]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData(prev => {
      const updated = { ...prev, [name]: value };

      return updated;
    });
  };

  const handleInputChangeCust = (e) => {
    const { name, value } = e.target;

    setNewCust(prev => {
      const updated = { ...prev, [name]: value };

      return updated;
    });
  };


  const fetchPurchase = async () => {
    try {
      const res = await axios.get(
        `https://api.dectwinbilling.com/fetch-purchase-bill/${clientData.id}`
      );
      setPurchaseBill(res.data);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchUnit = async () => {
    try {
      const res = await axios.get(`https://api.dectwinbilling.com/fetch-unit/${clientData.id}`);
      setunit(res.data);

    } catch (error) {
      console.log(error);
    }
  };

  const fetchCategory = async () => {
    try {
      const res = await axios.get(`https://api.dectwinbilling.com/fetch-category/${clientData.id}`);
      const filterCat =
        setCategory(res.data);

    } catch (error) {
      console.log(error);
    }
  };

  const fetchInventory = async () => {
    try {
      const res = await axios.get(`https://api.dectwinbilling.com/fetch-inventory/${clientData.id}`);
      setInventory(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  // const fetchbankAccount = async () => {
  //   try {
  //     const res = await axios.get(
  //       `https://api.dectwinbilling.com/fetch-bank-accounts/${clientData.id}`
  //     );

  //     const data =
  //       typeof res.data === "string"
  //         ? JSON.parse(res.data)
  //         : res.data;

  //     setBankList(data);

  //   } catch (error) {
  //     console.log(error);
  //   }
  // };
const fetchbankAccount = async () => {
  try {
    const res = await axios.get(
      `https://api.dectwinbilling.com/fetch-bank-accounts/${clientData.id}`
    );

    const data =
      typeof res.data === "string"
        ? JSON.parse(res.data)
        : res.data;

    console.log("BANK ACCOUNT API:", data);

    // API se null / object / array kuch bhi aaye,
    // bankList hamesha array rahega
    if (Array.isArray(data)) {
      setBankList(data);
    } else if (Array.isArray(data?.data)) {
      setBankList(data.data);
    } else if (Array.isArray(data?.banks)) {
      setBankList(data.banks);
    } else {
      setBankList([]);
    }

  } catch (error) {
    console.error("BANK ACCOUNT FETCH ERROR:", error);
    setBankList([]);
  }
};
  const fetchparty = async () => {
    try {
      const res = await axios.get(`https://api.dectwinbilling.com/fetch-party/${clientData.id}`);
      setPartyList(res.data);

    } catch (error) {
      console.log(error);
    }
  };

  const filteredParty = (partyList || []).filter((p) => {
    const searchText = search.toLowerCase();

    return (
      (p.name || "").toLowerCase().includes(searchText) ||
      (p.mobile || "").toLowerCase().includes(searchText) ||
      (p.gstin || "").toLowerCase().includes(searchText) ||
      (p.address || "").toLowerCase().includes(searchText)
    );
  });


  useEffect(() => {
    fetchPurchase();
    fetchCategory();
    fetchUnit();
    fetchInventory();
    fetchbankAccount();
    fetchparty();
  }, []);



const addRow = () => {
  setRows((prevRows) => [
    ...prevRows,
    {
      id: Date.now(),
      name: "",
      category: "",
      unit: "",
      price: "",
      qty: "",
      taxType: "Without Tax",
      taxRate: "",
      amount: "",
      discountType: "percent",
      discountValue: 0,
    },
  ]);
};
  // const addRow = () => {
  //   setRows([
  //     ...rows,
  //     {
  //       id: rows.length + 1,
  //       name: "",
  //       category: "",
  //       unit: "",
  //       price: "",
  //       qty: "",
  //       taxType: "Without Tax",
  //       taxRate: "",
  //       amount: "",
  //       discountType: "percent",
  //       discountValue: 0,
  //     },
  //   ]);
  // };


  const handleRowChange = (index, field, value) => {
    const updated = [...rows];
    updated[index][field] = value;
    setRows(updated);
  };
  useEffect(() => {
  if (rows.length === 0) return;

  const lastRow = rows[rows.length - 1];

  // Last row me item selected hai
  // to automatically next blank row add karo
  if (lastRow.inventory_id && lastRow.name) {
    const alreadyHasBlankRow =
      rows.length > 1 &&
      !rows[rows.length - 1].name &&
      !rows[rows.length - 1].inventory_id;

    if (!alreadyHasBlankRow) {
      addRow();
    }
  }
}, [rows]);
const handleSelectItem = (index, item) => {
  const updatedRows = [...rows];

  const discountType =
    item.discountType ||
    item.discount_type ||
    item.dis_type ||
    "percent";

  const discountValue = Number(
    item.discountValue ??
    item.discount_value ??
    item.discount ??
    0
  );

  const price = Number(item.sale_price || 0);

  const taxRate =
    item.taxRate ??
    item.tax_rate ??
    item.gst_rate ??
    item.gst ??
    "";

  const taxType =
    item.sale_price_withTax ??
    item.sale_price_with_tax ??
    item.taxType ??
    item.tax_type ??
    "Without Tax";

  updatedRows[index] = {
    ...updatedRows[index],

    inventory_id: item.id,

    name: item.name || "",
    category: item.category || "",
    unit: item.unit || "",

    mrp: Number(item.mrp || 0),
    pur_price: Number(item.pur_price || 0),
    price: price,

    // ⭐ TAX AUTO FILL
    taxRate: taxRate,
    taxType: taxType,

    typeOfItem: item.typeOfItem || "product",

    qty: 1,

    // ⭐ DISCOUNT AUTO FILL
    discountType: discountType,
    discountValue: discountValue,

    amount: price,
  };

  if (index === updatedRows.length - 1) {
    updatedRows.push({
      id: Date.now(),
      name: "",
      category: "",
      unit: "",
      price: "",
      qty: "",
      taxType: "Without Tax",
      taxRate: "",
      amount: "",
      discountType: "percent",
      discountValue: 0,
    });
  }

  setRows(updatedRows);
  setOpenItemDropdown(null);
  setItemSearch("");
};
// const handleSelectItem = (index, item) => {
//   const updatedRows = [...rows];

//   updatedRows[index] = {
//     ...updatedRows[index],

//     // Inventory ID
//     inventory_id: item.id,

//     // Product details
//     name: item.name || "",
//     // discount:item.discount||"",
//     category: item.category || "",
//     unit: item.unit || "",

//     // Prices
//     mrp: Number(item.mrp || 0),
//     pur_price: Number(item.pur_price || 0),
//     price: Number(item.sale_price || 0),

//     // Tax
//     taxRate: item.taxRate || "",
//     taxType: item.sale_price_withTax || "Without Tax",

//     // Item type
//     typeOfItem: item.typeOfItem || "product",

//     // Quantity
//     qty: 1,

//     // Amount
//     amount: Number(item.sale_price || 0),
//   };

//   // ✅ Product select hone ke baad
//   // last row hai to next blank row automatically add karo
//   if (index === updatedRows.length - 1) {
//     updatedRows.push({
//       id: Date.now(),
//       name: "",
//       category: "",
//       unit: "",
//       price: "",
//       qty: "",
//       taxType: "Without Tax",
//       taxRate: "",
//       amount: "",
//       discountType: "percent",
//       discountValue: 0,
//     });
//   }

//   setRows(updatedRows);

//   setOpenItemDropdown(null);
//   setItemSearch("");
// };

// const handleSelectItem = (index, item) => {
//   const updatedRows = [...rows];

//   updatedRows[index] = {
//     ...updatedRows[index],

//     // Inventory ID
//     inventory_id: item.id,

//     // Product details
//     name: item.name || "",
//     category: item.category || "",
//     unit: item.unit || "",

//     // IMPORTANT
//     mrp: Number(item.mrp || 0),
//     pur_price: Number(item.pur_price || 0),

//     // Sale price
//     price: Number(item.sale_price || 0),

//     // Tax
//     taxRate: item.taxRate || "",
//     taxType: item.sale_price_withTax || "Without Tax",

//     // IMPORTANT
//     typeOfItem: item.typeOfItem || "product",

//     // Quantity
//     qty: 1,

//     // Amount
//     amount: Number(item.sale_price || 0)
//   };

//   setRows(updatedRows);

//   setOpenItemDropdown(null);
//   setItemSearch("");
// };

  // const handleSelectItem = (index, item) => {
  //   const updatedRows = [...rows];

  //   updatedRows[index] = {
  //     ...updatedRows[index],

  //     name: item.name,
  //     category: item.category,
  //     unit: item.unit,
  //     price: Number(item.sale_price || 0),
  //     tax: item.taxRate,
  //     qty: 1,
  //     amount: Number(item.sale_price || 0) * 1,
  //   };

  //   setRows(updatedRows);
  // };
  const getFilteredInventory = () => {
  const searchText = itemSearch.trim().toLowerCase();

  if (!searchText) {
    return inventory;
  }

  return inventory.filter((item) =>
    (item.name || "").toLowerCase().includes(searchText)
  );
};



  const calculateRowAmount = (row) => {
    const qty = Number(row.qty || 0);
    const price = Number(row.price || 0);

    let base = qty * price;

    // discount
    if (row.discountValue) {
      if (row.discountType === "percent") {
        base -= (base * row.discountValue) / 100;
      } else {
        base -= Number(row.discountValue);
      }
    }

    const rate =
      parseFloat((row.taxRate || "").replace(/[^0-9.]/g, "")) || 0;


    if (row.taxType === "Without Tax") {
      base += (base * rate) / 100;
    }

    return base;
  };


  const totalQty = rows.reduce(
    (sum, row) => sum + Number(row.qty || 0),
    0
  );




  const returnAmount = rows.reduce(
    (sum, row) => sum + Number(row.amount || 0),
    0
  );

  const subTotal = useMemo(() => {
    return rows.reduce((sum, row) => {
      return sum + calculateRowAmount(row);
    }, 0);
  }, [rows]);



  // let discountedTotal = subTotal;

  const discountedTotal = useMemo(() => {
    let total = subTotal;

    if (billDiscount.value) {
      if (billDiscount.type === "percent") {
        total -= (subTotal * billDiscount.value) / 100;
      } else {
        total -= Number(billDiscount.value);
      }
    }

    return Math.max(0, total);
  }, [subTotal, billDiscount]);


  const calculateGST = (rows) => {
    let sgst = 0;
    let cgst = 0;
    let igst = 0;

    rows.forEach((row) => {
      const qty = Number(row.qty || 0);
      const price = Number(row.price || 0);

      let base = qty * price;

      if (row.discountValue) {
        if (row.discountType === "percent") {
          base -= (base * row.discountValue) / 100;
        } else {
          base -= Number(row.discountValue);
        }
      }

      const rate =
        parseFloat((row.taxRate || "").replace(/[^0-9.]/g, "")) || 0;

      const taxAmount = (base * rate) / 100;

      if (!row.taxRate) return;

      if (row.taxRate.startsWith("GST")) {
        sgst += taxAmount / 2;
        cgst += taxAmount / 2;
      } else if (row.taxRate.startsWith("IGST")) {
        igst += taxAmount;
      }
    });

    return {
      sgst,
      cgst,
      igst,
      totalTax: sgst + cgst + igst,
    };
  };

  // const buildItemsPayload = () => {
  //   return rows.map((row, index) => {
  //     const qty = Number(row.qty || 0);
  //     const price = Number(row.price || 0);

  //     const base = qty * price;

  //     // discount
  //     let discountAmount = 0;
  //     if (row.discountType === "percent") {
  //       discountAmount = (base * Number(row.discountValue || 0)) / 100;
  //     } else {
  //       discountAmount = Number(row.discountValue || 0);
  //     }

  //     const afterDiscount = base - discountAmount;

  //     // tax
  //     const taxRate = parseFloat(
  //       (row.taxRate || "").replace(/[^0-9.]/g, "")
  //     ) || 0;

  //     const taxAmount =
  //       row.taxType === "Without Tax"
  //         ? (afterDiscount * taxRate) / 100
  //         : 0;

  //     const finalAmount = afterDiscount + taxAmount;

  //     // const totalMRP = qty * mrp;

  //     return {
  //       id: row.id || null,
  //       SNo: index + 1,
  //       name: row.name,
  //       quant: qty,
  //       unit: row.unit,
  //       price_per_unit: price,
  //       discount: row.discountValue || 0,
  //       dis_type: row.discountType,
  //       taxRate: row.taxRate || "None",
  //       taxAmount: Number(taxAmount.toFixed(2)),
  //       amount: Number(finalAmount.toFixed(2)),

  //       category: row.category || "",
  //       pur_price: row.pur_price || 0,
  //       mrp: row.mrp || 0,
  //       typeOfItem: row.typeOfItem,
  //       sale_price_withTax: row.taxType || "Without Tax",

  //       stockReducer: ["", row.name, qty],
  //     };
  //   });
  // };

const buildItemsPayload = () => {
  return rows.map((row, index) => {
    const qty = Number(row.qty || 0);
    const price = Number(row.price || 0);

    const base = qty * price;

    let discountAmount = 0;

    if (row.discountType === "percent") {
      discountAmount =
        (base * Number(row.discountValue || 0)) / 100;
    } else {
      discountAmount =
        Number(row.discountValue || 0);
    }

    const afterDiscount =
      base - discountAmount;

    const taxRate =
      parseFloat(
        (row.taxRate || "").replace(/[^0-9.]/g, "")
      ) || 0;

    const taxAmount =
      row.taxType === "Without Tax"
        ? (afterDiscount * taxRate) / 100
        : 0;

    const finalAmount =
      afterDiscount + taxAmount;

    return {
      id: row.id || null,

      // IMPORTANT - actual inventory row id
      inventory_id: row.inventory_id || null,

      SNo: index + 1,

      name: row.name || "",

      quant: qty,

      unit: row.unit || "",

      price_per_unit: price,

      discount: Number(row.discountValue || 0),

      dis_type:
        row.discountType || "percent",

      taxRate:
        row.taxRate || "None",

      taxAmount:
        Number(taxAmount.toFixed(2)),

      amount:
        Number(finalAmount.toFixed(2)),

      category:
        row.category || "",

      pur_price:
        Number(row.pur_price || 0),

      mrp:
        Number(row.mrp || 0),

      typeOfItem:
        row.typeOfItem || "product",

      sale_price_withTax:
        row.taxType || "Without Tax",

      stockReducer: [
        "",
        row.name,
        qty
      ]
    };
  });
};




const handleSubmit = async () => {
  try {


    const paymentMethod = (
      formData.payment_method || ""
    )
      .trim()
      .toLowerCase();

    const isCashPayment =
      paymentMethod == "cash";

    


 if(!formData.payment_method){
  showWarning("Please select payment method!");
  return
 }




    const itemsPayload = buildItemsPayload();

    const validItems = itemsPayload.filter(
      (item) =>
        item.name &&
        String(item.name).trim() !== "" &&
        Number(item.quant || 0) > 0
    );

    if (validItems.length === 0) {
      showWarning("Please add at least one item");
      return;
    }

    // ==========================================
    // 4. GST
    // ==========================================
    const {
      sgst,
      cgst,
      igst,
      totalTax,
    } = calculateGST(rows);

    // ==========================================
    // 5. BANK
    // Cash -> 0
    // Other -> selected bank
    // ==========================================
    const bankId = isCashPayment
      ? 0
      : Number(selectedBankId || 0);
      if (!isCashPayment && !selectedBankId) {
  showWarning("Please select bank account!");
  return;
}

    // ==========================================
    // 6. TOTAL DISCOUNT
    // ==========================================
    const totalDis = rows.reduce(
      (total, row) => {
        const qty =
          Number(row.qty || 0);

        const price =
          Number(row.price || 0);

        const base =
          qty * price;

        let discountAmount = 0;

        if (row.discountType === "percent") {
          discountAmount =
            (base *
              Number(row.discountValue || 0)) /
            100;
        } else {
          discountAmount =
            Number(row.discountValue || 0);
        }

        return total + discountAmount;
      },
      0
    );

    // ==========================================
    // 7. TOTAL SALE PRICE
    // ==========================================
    const totalSP = rows.reduce(
      (total, row) => {
        const qty =
          Number(row.qty || 0);

        const price =
          Number(row.price || 0);

        return total + qty * price;
      },
      0
    );

    // ==========================================
    // 8. TOTAL MRP
    // ==========================================
    const totalMRP = rows.reduce(
      (total, row) => {
        const qty =
          Number(row.qty || 0);

        const mrp =
          Number(row.mrp || 0);

        return total + qty * mrp;
      },
      0
    );

    // ==========================================
    // 9. CUSTOMER DATA
    // ==========================================
    const customerId =  selectedParty?.id || null;

    const customerName =  selectedParty?.name || "";

    const customerAddress = selectedParty?.address || "";

    const customerMobile =  selectedParty?.mobile || "";

    const customerGstin =  selectedParty?.gstin || "";

    const loyaltyRedeem = isCashPayment
      ? 0
      : Number(
          selectedParty?.loyality_redeem || 0
        );

    const loyaltyPercent = isCashPayment
      ? 0
      : Number(
          selectedParty?.loyality || 0
        );

    // ==========================================
    // 10. FINAL PAYLOAD
    // ==========================================
    const payload = {
      // Customer
      cId: customerId,
      cust_name: customerName || "cash",
      cust_address: customerAddress,
      cust_number: customerMobile,
      gstin: customerGstin,

      // Loyalty
      loyality_redeem: loyaltyRedeem,
      loyalty_percent: loyaltyPercent,

      // Amounts
      payable: Number(
        payableAmount.toFixed(2)
      ),

      recieved: Number(
        paidAmount || 0
      ),

      due: Number(
        dueAmount.toFixed(2)
      ),

      // Invoice
      date: estimateDate,
      seller: formData.seller_name || "",

      // Items
      items: validItems,

      // Payment
      payment_method:
        formData.payment_method || null,

      acc_id: bankId,

      // Bill Discount
      last_discount: Number(
        billDiscount.value || 0
      ),

      last_discount_type:
        billDiscount.type === "percent"
          ? "Percentage"
          : "Amount",

      onChangeForDiscount:
        billDiscount.type === "percent"
          ? Number(
              billDiscount.value || 0
            )
          : 0,

      // Totals
      totalSP: Number(
        totalSP.toFixed(2)
      ),

      totalDis: Number(
        totalDis.toFixed(2)
      ),

      total_mrp: Number(
        totalMRP.toFixed(2)
      ),

      totalMRP: Number(
        totalMRP.toFixed(2)
      ),

      total_pp: 0,
      totalPP: 0,
      total_saveOnMrp: 0,

      // GST
      sgst: Number(
        sgst.toFixed(2)
      ),

      cgst: Number(
        cgst.toFixed(2)
      ),

      igst: Number(
        igst.toFixed(2)
      ),

      totalTax: Number(
        totalTax.toFixed(2)
      ),

      // Other
      description:
        description || "",

      client_type:
        role || "",
    };

    console.log(
      "FINAL SALE PAYLOAD:",
      payload
    );

    // ==========================================
    // 11. EDIT SALE
    // ==========================================
    let res;

    if (isEditMode) {
      payload.last_edited_by =
        clientData.id;

      payload.last_edited =
        new Date();

      payload.last_edited_type =
        clientData.role;

      payload.client_id =
        editData.client_id;

      res = await axios.put(
        `https://api.dectwinbilling.com/api/update-new-sale/${currId}`,
        payload
      );

      showSuccess(
        "Sale Bill updated successfully"
      );

      navigate(
        "/invoice-preview",
        {
          state: {
            invoice: {
              ...payload,

              invoiceNo:
                res.data?.invoiceNo ||
                res.data?.data?.invoiceNo ||
                invoiceNo,
            },

            billTitle:
              "SALE INVOICE",
          },
        }
      );
    }

    // ==========================================
    // 12. NEW SALE
    // ==========================================
    else {
      res = await axios.post(
        `https://api.dectwinbilling.com/api/add-new-sale-bill/${clientData.id}`,
        payload
      );

      showSuccess(
        "Sale Invoice created successfully"
      );
      console.log(res.data,"addsale")

      navigate(
        "/invoice-preview",
        {
          state: {
            invoice: {
              ...payload,

              invoiceNo:
                res.data?.invoiceNo ||
                res.data?.data?.invoiceNo ||
                invoiceNo,
            },

            billTitle:
              "SALE INVOICE",
          },
        }
      );
    }

    // ==========================================
    // 13. RESET
    // ==========================================
    resetForm();

  } catch (err) {
    console.error(
      "SALE SUBMIT ERROR:",
      err.response?.data || err
    );

    showError(
      err.response?.data?.message ||
      (
        isEditMode
          ? "Failed to update sale bill"
          : "Failed to save sale bill"
      )
    );
  }
};

  const { sgst, cgst, igst, totalTax } = useMemo(() => {
    return calculateGST(rows);
  }, [rows]);


  const resetForm = () => {
    setReturnDate(new Date().toISOString().split("T")[0]);

    // Party Details
    setSelectedParty(null);
    setPartyName("");
    setPartyAddress("");
    setPartyGst("");
    setPartyNo("");

    // Seller
    setFormData((prev) => ({
      ...prev,
      seller_name: "",
      payment_method: "",
      cb_payid: 0,
    }));

    // Bank
    setSelectedBankId(0);

    // Description
    setDescription("");

    // Bill Discount
    setBillDiscount({
      type: "percent",
      value: 0,
    });

    // Payment
    setIsFullyPaid(false);
    setPaidAmount(0);
    setReceived(0);
    setDue(0);

    // Party Visit Details
    setVisitParty(0);
    setOriginalTotalPur(0);
    setPreviousBalance(0);

    // Return
    setReturnAgainst("");

    // Items
    setRows([
      {
        id: 1,
        name: "",
        category: "",
        unit: "",
        price: "",
        qty: "",
        tax: "",
        amount: "",
        taxMode: "GST",
        taxRate: 0,
        taxType: "Without Tax",
        discountType: "percent",
        discountValue: 0,
      },
    ]);
  };

  const paymentMethod = formData.payment_method || editData?.mode;

  const taxableTotal = useMemo(() => {
    return rows.reduce((sum, row) => sum + calculateRowAmount(row), 0);
  }, [rows]);

  const discountAmount = useMemo(() => {
    if (!billDiscount.value) return 0;

    if (billDiscount.type === "percent") {
      return (taxableTotal * billDiscount.value) / 100;
    }

    return billDiscount.value;
  }, [taxableTotal, billDiscount]);

  const payableAmount = Math.max(taxableTotal - discountAmount, 0);

  // const payableAmount = Math.max(grandTotal - discountAmount, 0);

  const paid = isFullyPaid ? payableAmount : Number(paidAmount || 0);

  // const dueAmount = Math.max(payableAmount - paid, 0);

  const dueAmount = Math.max(payableAmount - Number(paidAmount || 0), 0);


  const getBillState = () => ({
    invoiceNo,
    estimateDate,
    formData,
    selectedParty,
    rows,
    billDiscount,
    description,
    paidAmount,
    isFullyPaid,
    selectedBankId,
    payableAmount,
  });

  // const clearBill = () => {
  //   resetForm();
  //   setShowExitModal(false);
  //   navigate("/home");
  // };
const clearBill = () => {
  resetForm();
  setShowExitModal(false);

  if (isEditFromSaleHistory) {
    navigate("/sale-history");
  } else {
    navigate("/home");
  }
};
  const MAX_HELD_BILLS = 5;
  const holdBill = () => {
    const heldBills =
      JSON.parse(localStorage.getItem("heldBills")) || {};

    if (Object.keys(heldBills).length >= MAX_HELD_BILLS) {
      toast.error("Maximum limit of 5 held bills reached. Please resume or clear a held bill before holding another.");
      return;
    }

    const key = `Bill ${Object.keys(heldBills).length + 1}`;

    heldBills[key] = getBillState();

    localStorage.setItem(
      "heldBills",
      JSON.stringify(heldBills)
    );

    setShowExitModal(false);
    navigate("/home");
  };

  const heldBills =
    JSON.parse(localStorage.getItem("heldBills")) || {};

  const loadBill = (key) => {
    const heldBills = JSON.parse(localStorage.getItem("heldBills")) || {};

    const bill = heldBills[key];

    if (!bill) return;

    setInvoiceNo(bill.invoiceNo);
    setEstimateDate(bill.estimateDate);
    setFormData(bill.formData);
    setSelectedParty(bill.selectedParty);
    setRows(bill.rows);
    setBillDiscount(bill.billDiscount);
    setDescription(bill.description);
    setPaidAmount(bill.paidAmount);
    setIsFullyPaid(bill.isFullyPaid);
    setSelectedBankId(bill.selectedBankId);

    // Remove the bill after loading (optional)
    delete heldBills[key];

    localStorage.setItem(
      "heldBills",
      JSON.stringify(heldBills)
    );
  };


  const handleSubmitParty = async (e) => {
    e.preventDefault();

    if (!newCust.name) {
      showWarning("Name  are required!", "danger");
      return;
    }

    try {
      const today = new Date().toISOString().split("T")[0];


      const sendData = {
        name: newCust.name,
        mobile: newCust.mobile,
        gstin: newCust.gstin,
        email: newCust.email,

        gst_type: newCust.gst_type,
        gst_state: newCust.gst_state,
        address: newCust.address,
        opening_balance: newCust.opening_balance,
        asOfDate: newCust.asOfDate,
        p_type: "Customer",
        client_id: clientData.id,
        first_visit: today,
        last_visit: today,
        total_pur: 0,
        total_due: 0,
        loyality: 0,
        visits: 0,
        opening_bal_status: '',
        balance: 0,
      };

      let res;



      res = await axios.post(
        "https://api.dectwinbilling.com/add-party",
        sendData
      );

      const newPartyId = res.data.insertedId;

      const partyRes = await axios.get(
        `https://api.dectwinbilling.com/get-party/${newPartyId}`
      );

      const createdParty = partyRes.data.party;

      showSuccess("Party Added Successfully!", "success");
      resetFormParty();

      setSelectedParty(createdParty);
      setIsNewParty(false);
      setShowPartyForm(false);
      setPartyName(createdParty.name);
      setPartyNo(createdParty.mobile || "");
      setPartyAddress(createdParty.address || "");
      setPartyGst(createdParty.gstin || "");

      fetchparty();

    } catch (err) {
      console.error("❌ Error:", err.response?.data || err.message);

      showError(
        err.response?.data?.message || "Failed to save party!",
        "danger"
      );
    }
  };

  const resetFormParty = () => {
    setNewCust({
      name: '',
      first_visit: '',
      last_visit: '',
      mobile: '',
      email: "",
      total_pur: "",
      total_due: "",
      loyality: '',
      visits: "",
      gstin: '',
      gst_type: '',
      gst_state: '',
      address: '',
      history: '',
      opening_balance: '',
      opening_bal_status: '',
      balance: '',
      asOfDate: '',
      p_type: '',
      client_id: ''
    })

  }


  return (
    <div>
      <div className="page-wrapper">

        <div className="page-content">


          <div className="page-header d-flex align-items-center justify-content-start mb-3">
            <div className="d-flex align-items-center gap-2">
              <FaArrowCircleLeft
                style={{ cursor: "pointer", fontSize: "24px" }}
                // onClick={() => navigate("/home")}
                onClick={() => setShowExitModal(true)}
              />

              <h4 className="mb-0">Sale</h4>
            </div>

            <div className="d-flex gap-2 flex-wrap">


              {Object.keys(heldBills).map((key) => (
                <button
                  key={key}
                  className="btn btn-success me-2"
                  onClick={() => loadBill(key)}
                >
                  {key}
                </button>
              ))}
            </div>
          </div>

          <div className="container-fluid mt-3">
            <div className="row g-3">


              <div className="col-md-4">

                <div
                  className=" p-4 rounded shadow-sm"
                  style={{ width: "300px", backgroundColor: 'var(--card-color)' }}
                >
                  {/* Estimate No */}

                  {isEditMode && (
                  <div className="mb-3 position-relative">
                    <input
                      type="text"
                      readOnly
                      className="form-control"
                      style={{ paddingLeft: "115px" }}
                      value={invoiceNo}
                    />
                    <span
                      className="position-absolute top-50 start-0 translate-middle-y ms-1 fw-medium"
                    >
                      Invocie No:
                    </span>
                  </div>
                    )}

                  {/* Estimate Date */}
                  <div className="mb-3 position-relative ">
                    <input
                      type="datetime-local"
                      className="form-control"
                      style={{ paddingLeft: "100px" }}
                      value={estimateDate}
                      onChange={(e) => setEstimateDate(e.target.value)}
                    />
                    <span
                      className="position-absolute top-50 start-0 translate-middle-y ms-1 fw-medium"
                      style={{ pointerEvents: "none" }}
                    >
                      Invoice Date:
                    </span>
                  </div>

                  <div className="position-relative ">
                    <input
                      type="text"
                      className="form-control"
                      style={{ paddingLeft: "115px" }}
                      name='seller_name'
                      value={formData.seller_name}
                      onChange={handleInputChange}
                    />
                    <span
                      className="position-absolute top-50 start-0 translate-middle-y ms-1 fw-medium"
                      style={{ pointerEvents: "none" }}

                    >
                      Seller Name:
                    </span>
                  </div>


                </div>
              </div>



              <div className="col-md-4 ms-auto">
                <div className="d-flex justify-content-end mb-2">
                  {/* <button
                    className="btn-party"
                    onClick={() => setShowPartyForm(true)}
                  >
                    + Add Customer
                  </button> */}
                 <button
  type="button"
  className="btn btn-primary"
  onClick={() => {
    setSearch("");
    setShowPartyModal(true);
  }}
>
  Select Party
</button>
                </div>
<div className="d-flex align-items-center mb-2">
  <span
    className="me-2 flex-shrink-0 fw-medium"
    style={{ width: "130px" }}
  >
    Customer Name:
  </span>

  <input
    type="text"
    className="form-control"
    placeholder="Enter Customer Name"
    value={partyName}
    onChange={(e) => {
      setPartyName(e.target.value);

      setSelectedParty((prev) => ({
        ...(prev || {}),
        name: e.target.value,
      }));
    }}
  />
</div>


<div className="d-flex align-items-center mb-2">
  <span
    className="me-2 flex-shrink-0 fw-medium"
    style={{ width: "130px" }}
  >
    Mobile Number:
  </span>

  <input
    type="text"
    className="form-control"
    placeholder="Enter Mobile Number"
    value={partyNo}
    maxLength={10}
    onChange={(e) => {
      const value = e.target.value.replace(/\D/g, "");
      setPartyNo(value);

      setSelectedParty((prev) => ({
        ...(prev || {}),
        mobile: value,
      }));
    }}
  />
</div>


<div className="d-flex align-items-center mb-2">
  <span
    className="me-2 flex-shrink-0 fw-medium"
    style={{ width: "130px" }}
  >
    Address:
  </span>

  <input
    type="text"
    className="form-control"
    placeholder="Enter Address"
    value={partyAddress}
    onChange={(e) => {
      setPartyAddress(e.target.value);

      setSelectedParty((prev) => ({
        ...(prev || {}),
        address: e.target.value,
      }));
    }}
  />
</div>


<div className="d-flex align-items-center">
  <span
    className="me-2 flex-shrink-0 fw-medium"
    style={{ width: "130px" }}
  >
    GSTIN Number:
  </span>

  <input
    type="text"
    className="form-control"
    placeholder="Enter GSTIN Number"
    value={partyGst}
    onChange={(e) => {
      setPartyGst(e.target.value.toUpperCase());

      setSelectedParty((prev) => ({
        ...(prev || {}),
        gstin: e.target.value.toUpperCase(),
      }));
    }}
  />
</div>

              </div>

            </div>
          </div>

          <div className="container-fluid mt-3">
            <div className="table-wrapper p-2">

              <table className="table table-bordered custom-table mb-0"
                style={{ tableLayout: "fixed" }}
              >

                <thead className="table-light">
                  <tr>
                    <th style={{ width: "70px" }}>SN</th>
                    <th style={{ width: "250px" }}>Item</th>
                    <th style={{ width: "90px" }}>Qty</th>
                    <th style={{ width: "140px" }}>Unit</th>
                    <th style={{ width: "140px" }}>Price/Unit</th>
                    <th style={{ width: "240px" }}>Discount</th>
                    <th style={{ width: "260px" }}>Tax</th>
                    <th style={{ width: "140px" }}>Amount</th>
                  </tr>
                </thead>

                <tbody>
                  {rows.map((row, index) => (
                    <tr key={row.id}>
                      <td>
                        <div className="d-flex align-items-center gap-2">
                          <span>{index + 1}</span>

                          <FaTrash
                            color="red"
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              setRows(rows.filter((_, i) => i !== index))
                            }
                          />
                        </div>
                      </td>

                      {/* <td>
                        <select
                          className="form-select form-select-sm"
                          style={{ width: "100%" }}
                          value={row.name}
                          onChange={(e) => {
                            const item = inventory.find(
                              (inv) => inv.name === e.target.value
                            );

                            if (item) {
                              handleSelectItem(index, item);
                            }
                          }}
                        >
                          <option value="">Select Item</option>

                          {inventory.map((item) => (
                            <option key={item.id} value={item.name}>
                              {item.name}
                            </option>
                          ))}
                        </select>
                      </td> */}
<td style={{ position: "relative" }}>
  <div style={{ position: "relative" }}>

    {/* Selected Item / Search Input */}
    <input
      type="text"
      className="form-control form-control-sm"
      placeholder="Select / Search Item..."
      value={
        openItemDropdown === index
          ? itemSearch
          : row.name || ""
      }
      onFocus={() => {
        setOpenItemDropdown(index);
        setItemSearch("");
      }}
      onChange={(e) => {
        setOpenItemDropdown(index);
        setItemSearch(e.target.value);
      }}
      onBlur={() => {
        // Delay closing so item click works
        setTimeout(() => {
          setOpenItemDropdown(null);
          setItemSearch("");
        }, 200);
      }}
    />

    {/* Dropdown */}
    {openItemDropdown === index && (
      <div
        style={{
          position: "absolute",
          top: "100%",
          left: 0,
          right: 0,
          zIndex: 9999,
          background: "white",
          border: "1px solid #ccc",
          borderRadius: "6px",
          maxHeight: "250px",
          overflowY: "auto",
          boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
        }}
      >
        {getFilteredInventory().length > 0 ? (
          getFilteredInventory().map((item) => (
            <div
              key={item.id}
              onMouseDown={(e) => {
                e.preventDefault();

                handleSelectItem(index, item);

                setOpenItemDropdown(null);
                setItemSearch("");
              }}
              style={{
                padding: "9px 12px",
                cursor: "pointer",
                borderBottom: "1px solid #eee",
                backgroundColor: "#fff",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#f5f5f5";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "#fff";
              }}
            >
              {item.name}
            </div>
          ))
        ) : (
          <div
            style={{
              padding: "12px",
              textAlign: "center",
              color: "#888",
            }}
          >
            No item found
          </div>
        )}
      </div>
    )}

  </div>
</td>


                      <td>
                        <input
                          type="number"
                          className="form-control form-control-sm text-center"
                          value={row.qty || ""}
                          onChange={(e) => {
                            const updatedRows = [...rows];

                            const qty = Number(e.target.value) || 0;
                            const price = Number(updatedRows[index].price) || 0;

                            updatedRows[index].qty = qty;
                            // updatedRows[index].amount = qty * price;
                            // updatedRows[index].amount = calculateRowAmount(updatedRows[index]);
                            setRows(updatedRows);
                          }}
                        />
                      </td>



                      <td>
                        <select
                          className="form-select form-select-sm"
                          style={{ width: "100%" }}
                          value={row.unit || ""}
                          onChange={(e) => {
                            const updatedRows = [...rows];
                            updatedRows[index].unit = e.target.value;
                            setRows(updatedRows);
                          }}
                        >
                          <option value="">Select Unit</option>

                          {unit.map((u) => (
                            <option
                              key={u.id}
                              value={u.cat_name}
                            >
                              {u.cat_name}
                            </option>
                          ))}
                        </select>
                      </td>


                      <td>
                        <input
                          type="number"
                          className="form-control form-control-sm text-end"
                          value={row.price || ""}
                          onChange={(e) => {
                            const updatedRows = [...rows];

                            const price = Number(e.target.value) || 0;
                            const qty = Number(updatedRows[index].qty) || 0;

                            updatedRows[index].price = price;
                            // updatedRows[index].amount = qty * price;
                            // updatedRows[index].amount = calculateRowAmount(updatedRows[index]);
                            setRows(updatedRows);
                          }}
                        />
                      </td>


                      <td>
                        <div className="d-flex gap-2 align-items-center">

                          <select
                            className="form-select form-select-sm"
                            style={{ minWidth: "110px" }}
                            value={row.discountType}
                            onChange={(e) => {
                              const updated = [...rows];
                              updated[index].discountType = e.target.value;

                              // updated[index].amount = calculateRowAmount(updated[index]);

                              setRows(updated);
                            }}
                          >
                            <option value="percent">Percent (%)</option>
                            <option value="amount">Amount (₹)</option>
                          </select>

                          <input
                            type="number"
                            className="form-control form-control-sm text-end"
                            value={row.discountValue || ""}
                            onChange={(e) => {
                              const updated = [...rows];

                              updated[index].discountValue = Number(e.target.value);

                              // updated[index].amount = calculateRowAmount(updated[index]);

                              setRows(updated);
                            }}
                          />

                        </div>
                      </td>

                      <td>
                        <div className="d-flex gap-2">

                          <select
                            className="form-select form-select-sm"
                            style={{ width: "130px" }}
                            value={row.taxType}
                            onChange={(e) => {
                              const updated = [...rows];
                              updated[index].taxType = e.target.value;

                              // updated[index].amount = calculateRowAmount(updated[index]);

                              setRows(updated);
                            }}
                          >
                            <option value="With Tax">With Tax</option>
                            <option value="Without Tax">Without Tax</option>
                          </select>
                          <select
                            className="form-select form-select-sm"
                            style={{ width: "130px" }}
                            value={row.taxRate}
                            onChange={(e) => {
                              const updated = [...rows];

                              const value = e.target.value;
                              updated[index].taxRate = value;

                              // updated[index].amount = calculateRowAmount(updated[index]);

                              setRows(updated);
                            }}
                          >
                            <option value="">Tax Rate</option>

                            <option value="GST 0%">GST 0%</option>
                            <option value="IGST 0%">IGST 0%</option>

                            <option value="GST 0.25%">GST 0.25%</option>
                            <option value="IGST 0.25%">IGST 0.25%</option>

                            <option value="GST 3%">GST 3%</option>
                            <option value="IGST 3%">IGST 3%</option>

                            <option value="GST 5%">GST 5%</option>
                            <option value="IGST 5%">IGST 5%</option>

                            <option value="GST 12%">GST 12%</option>
                            <option value="IGST 12%">IGST 12%</option>

                            <option value="GST 18%">GST 18%</option>
                            <option value="IGST 18%">IGST 18%</option>

                            <option value=">GST 28%">GST 28%</option>
                            <option value="IGST 28%">IGST 28%</option>
                          </select>

                        </div>
                      </td>


                      <td className="fw-bold text-end text-success">
                        ₹ {calculateRowAmount(row).toFixed(2)}
                      </td>

                    </tr>
                  ))}
                </tbody>

              </table>

              <div className="text-center mt-2">
                <FaPlusCircle
                  size={35}
                  color="var(--primary-color)"
                  style={{ cursor: "pointer" }}
                  onClick={addRow}
                />
              </div>

            </div>
          </div>

          <div className="container-fluid mt-3">
            <div className="summary-box">
              <div className="summary-left">
                <strong>Total</strong>
              </div>

              <div className="summary-right">
                <div>{totalQty} </div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div> ₹ {totalTax.toFixed(2)}</div>
                <div>₹ {subTotal}</div>
              </div>
            </div>
          </div>

          <div className="container-fluid mt-3 mb-3">
            <div className="row align-items-stretch">

              {/* Discount Card */}
              <div className="col-md-4">
                <div
                  className="card p-3"
                  style={{ backgroundColor: "var(--card-color)" }}
                >
                  {/* Discount */}
                  <h6 className="fw-bold mb-3 text-primary">Discount</h6>

                  <div className="d-flex gap-2 mb-4">
                    <select
                      className="form-select"
                      style={{ minWidth: "140px" }}
                      value={billDiscount.type}
                      onChange={(e) =>
                        setBillDiscount({ ...billDiscount, type: e.target.value })
                      }
                    >
                      <option value="percent">Percent (%)</option>
                      <option value="amount">Amount (₹)</option>
                    </select>

                    <input
                      type="number"
                      className="form-control"
                      value={billDiscount.value}
                      onChange={(e) =>
                        setBillDiscount({
                          ...billDiscount,
                          value: Number(e.target.value),
                        })
                      }
                    />


                  </div>

                 <h6 className="fw-bold mb-3 text-primary">Payment Method</h6>

<div
  className="border rounded-4 h-100 mb-4"
  style={{ backgroundColor: "var(--card-color)" }}
>
  <select
    className="form-select"
    name="payment_method"
    value={formData.payment_method}
    onChange={(e) => {
      const value = e.target.value;

      setFormData((prev) => ({
        ...prev,
        payment_method: value,
        cb_payid: value === "Cash" ? 0 : "",
      }));

      // Cash = bank account nahi chahiye
      if (value === "Cash") {
        setSelectedBankId(0);
      }

      // UPI / Debit Card / Credit Card
      // = bank account select karna hoga
      if (["UPI", "Bank", "Card"].includes(value)) {
        setSelectedBankId("");
      }
    }}
    disabled={isEditMode}
    required
  >
    <option value="">Select payment method</option>

    <option value="Cash">
      Cash
    </option>

    <option value="UPI">
      UPI
    </option>

    <option value="Bank">
      Debit Card
    </option>

    <option value="Card">
      Credit Card
    </option>
  </select>
</div>

{/* BANK ACCOUNT DROPDOWN */}

{/* BANK ACCOUNT DROPDOWN */}

{/* <div className="col-md-4">
  {["UPI", "Bank", "Card"].includes(formData.payment_method) && (
    <div className="mt-2">

      <div className="fw-bold mb-2">
        {formData.payment_method === "UPI"
          ? "Select Bank Account for UPI"
          : formData.payment_method === "Bank"
          ? "Select Bank Account for Debit Card"
          : "Select Bank Account for Credit Card"}
      </div>

      <select
        className="form-select form-select-sm"
        value={selectedBankId || ""}
        onChange={(e) => {
          const bankId = Number(e.target.value);

          setSelectedBankId(bankId);

          setFormData((prev) => ({
            ...prev,
            cb_payid: bankId,
          }));
        }}
        required
      >
        <option value="">
          {Array.isArray(bankList) && bankList.length > 0
            ? "Select Bank Account"
            : "No Bank Account Added"}
        </option>

        {Array.isArray(bankList) &&
          bankList.map((bank) => (
            <option
              key={bank.id}
              value={bank.id}
            >
              {bank.account_holder || "Account Holder"}
              {" - "}
              {bank.bank_name || "Bank"}
              {bank.account_number
                ? ` (${bank.account_number})`
                : ""}
            </option>
          ))}
      </select>

      {(!Array.isArray(bankList) || bankList.length === 0) && (
        <small className="text-danger d-block mt-1">
          Please add a bank account first.
        </small>
      )}

    </div>
  )}
</div> */}


                  {/* Description */}
                  <h6 className="fw-bold mb-2 text-primary">Description</h6>

                  <textarea
                    className="form-control"
                    rows="4"
                    placeholder="Enter description..."
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                  />
                </div>



              </div>

              {/* <div className="col-md-4">
                {!isEditMode && paymentMethod && paymentMethod !== "Cash" && (
                  <div className="mt-2">

                    <div className="fw-bold mb-2">
                      Select Bank Account
                    </div>


                    <select
                      className="form-select form-select-sm"
                      value={selectedBankId || ""}

                      onChange={(e) => {
                        const bankId = Number(e.target.value);

                        setSelectedBankId(bankId);

                        setFormData((prev) => ({
                          ...prev,
                          cb_payid: bankId,
                        }));
                      }}
                    >
                      <option value="">Select Bank</option>

                      {bankList.map((bank) => (
                        <option key={bank.id} value={bank.id}>
                          {bank.account_holder} ({bank.bank_name})
                        </option>
                      ))}
                    </select>

                  </div>
                )}
              </div> */}
<div className="col-md-4">
  {!isEditMode &&
    formData.payment_method &&
    formData.payment_method !== "Cash" && (
      <div className="mt-2">
        <div className="fw-bold mb-2">
          Select Bank Account
        </div>

        <select
          className="form-select form-select-sm"
          value={selectedBankId || ""}
          onChange={(e) => {
            const bankId = Number(e.target.value);

            setSelectedBankId(bankId);

            setFormData((prev) => ({
              ...prev,
              cb_payid: bankId,
            }));
          }}
          required
        >
          <option value="">Select Bank</option>

          {bankList.map((bank) => (
            <option key={bank.id} value={bank.id}>
              {bank.account_holder} ({bank.bank_name})
            </option>
          ))}
        </select>
      </div>
    )}
</div>

              <div className="col-md-4">

                <div
                  style={{
                    background: "#ece7e7",
                    padding: "15px",
                    borderRadius: "15px",
                    width: "100%",
                    maxWidth: "350px",
                  }}
                >

                  <div className="invoice-box">
                    Payable Amount : ₹ {payableAmount.toFixed(2)}
                  </div>


                  <div className="invoice-box d-flex align-items-center gap-2">
                    <input
                      type="checkbox"
                      checked={isFullyPaid}
                      onChange={(e) => {
                        const checked = e.target.checked;
                        setIsFullyPaid(checked);

                        if (checked) {
                          setPaidAmount(payableAmount);
                        }else {
      setPaidAmount(0);
    }
                      }}
                    />

                    <span>Paid Amount :</span>

                    <input
                      type="number"
                      value={paidAmount}
                      min="0"
                      max={payableAmount}
                      // onChange={(e) => {
                      //   const value = Number(e.target.value);

                      //   setPaidAmount(value);
                      //   setIsFullyPaid(value === payableAmount);
                      // }}

                      onChange={(e) => {
    let value = Number(e.target.value);

    if (value < 0) value = 0;
    if (value > payableAmount) value = payableAmount;

    setPaidAmount(value);
    setIsFullyPaid(value === payableAmount);
  }}
                      style={{
                        width: "120px",
                        padding: "4px",
                      }}
                    />
                  </div>


                  {/* <div
                    className="invoice-box"
                    style={{ color: "red", fontWeight: "bold" }}
                  >
                    Due Amount : ₹ {isEditMode
                      ? Number(editData?.due || 0).toFixed(2)
                      : (payableAmount - paidAmount).toFixed(2)}
                  </div> */}


                  <div
  className="invoice-box"
  style={{ color: "red", fontWeight: "bold" }}
>
  Due Amount : ₹ {dueAmount.toFixed(2)}
</div>
                </div>

              </div>

            </div>
          </div>

        </div>

        <div className="footer-bar mt-4">
          <button className="btn-clear btn btn-secondary" onClick={() => resetForm()} >Clear Bill</button>
          {/* <button className="btn-save btn btn-success" onClick={handleSubmit} >  {isEditMode ? "Update & Print" : "Save & Print"}</button> */}
          <button className="btn-preview btn btn-primary" onClick={handleSubmit} >  {isEditMode ? "Update & Share" : "Preview & Share"}</button>
        </div>

      </div>

      {showPartyModal && (
        <div
          className="modal show fade d-block"
          tabIndex="-1"
          style={{ backgroundColor: "rgba(0,0,0,0.6)" }}
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content shadow-lg border-0 rounded-3">


              <div className="modal-header  text-white" style={{ backgroundColor: 'var(--primary-color)' }}>
                <h5 className="modal-title text-white">Select Party</h5>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  onClick={() => setShowPartyModal(false)}
                />
              </div>


              <div className="modal-body">

                <input
                  type="text"
                  className="form-control mb-3"
                  placeholder="Search by name, mobile, GST..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />


                <div
                  className="list-group"
                  style={{ maxHeight: "350px", overflowY: "auto" }}
                >
                  {filteredParty.length > 0 ? (
                    filteredParty.map((p) => (
                      <button
                        key={p.id}
                        type="button"
                        className="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
                     onClick={() => {
  setSelectedParty(p);


  setPartyName(p.name || "");
  setPartyNo(p.mobile || "");
  setPartyAddress(p.address || "");
  setPartyGst(p.gstin || "");

  setShowPartyModal(false);
  setSearch("");
}}
                      >
                        <div>
                          <div className="fw-bold">{p.name}</div>
                          <small className="text-muted">
                            {p.mobile} | GST: {p.gstin || "NA"}
                          </small>
                        </div>

                        <span className="badge bg-success">
                          Select
                        </span>
                      </button>
                    ))
                  ) : (
                    <div className="text-center text-muted py-3">
                      No party found
                    </div>
                  )}
                </div>
              </div>

<div className="modal-footer justify-content-between">



  {/* CLOSE */}
  <button
    type="button"
    className="btn-credit"
    onClick={() => {
      setShowPartyModal(false);
      setSearch("");
    }}
  >
    Close
  </button>

</div>
              {/* <div className="modal-footer justify-content-end">


                <button
                  className="btn-credit"
                  onClick={() => setShowPartyModal(false)}
                >
                  Close
                </button>
              </div> */}

            </div>
          </div>
        </div>
      )}

      {showExitModal && (
        <div
          className="modal show d-block"
          style={{ background: "rgba(0,0,0,.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">

              <div className="modal-header">
                <h5>Leave Bill?</h5>
              </div>

              <div className="modal-body">
                <p>What would you like to do with this bill?</p>
              </div>

              <div className="modal-footer">
                <button
                  className="btn btn-danger"
                  onClick={clearBill}
                >
                  Clear Bill
                </button>

                <button
                  className="btn btn-warning"
                  onClick={holdBill}
                >
                  Hold Bill
                </button>

                <button
                  className="btn btn-secondary"
                  onClick={() => setShowExitModal(false)}
                >
                  Cancel
                </button>

              </div>

            </div>
          </div>
        </div>
      )}

{showPartyForm && (
  <div
    className="modal fade show d-block"
    tabIndex="-1"
    role="dialog"
    aria-modal="true"
    style={{
      backgroundColor: "rgba(0, 0, 0, 0.55)",
    }}
  >
    <form onSubmit={handleSubmit}>
      <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg px-2">
        <div className="modal-content border-0 shadow-lg rounded-4">

          {/* =========================
              HEADER
          ========================== */}
          <div className="modal-header px-4 py-3">

            <h5
              className="modal-title fw-bold mb-0"
              style={{
                color: "#2583e8",
              }}
            >
              {isEditMode ? "Edit Party" : "Party Details"}
            </h5>

            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={() => {
                setShowPartyForm(false);
            
                resetForm();
              }}
            />
          </div>


          {/* =========================
              BODY
          ========================== */}
          <div className="modal-body px-4 py-3">

            <div className="row g-3">

              {/* =========================
                  LEFT SECTION
              ========================== */}
              <div className="col-12 col-md-6">

                {/* PARTY NAME */}
                <div className="mb-3">
                  <label className="form-label fw-semibold mb-1">
                    Party Name :
                  </label>

                  <input
                    type="text"
                    className="form-control"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required={!isEditMode}
                  />
                </div>


                {/* PARTY CONTACT */}
                <div className="mb-3">
                  <label className="form-label fw-semibold mb-1">
                    Party Contact :
                  </label>

                  <input
                    type="text"
                    className="form-control"
                    name="mobile"
                    value={formData.mobile}
                    onChange={handleInputChange}
                    maxLength={10}
                    required={!isEditMode}
                  />
                </div>


                {/* PARTY GSTIN */}
                <div className="mb-3">
                  <label className="form-label fw-semibold mb-1">
                    Party GSTIN :
                  </label>

                  <input
                    type="text"
                    className="form-control"
                    name="gstin"
                    value={formData.gstin}
                    onChange={handleInputChange}
                    disabled={formData.gst_type === "Unregistered"}
                  />
                </div>


                {/* PARTY EMAIL */}
                <div className="mb-3">
                  <label className="form-label fw-semibold mb-1">
                    Party Email :
                  </label>

                  <input
                    type="email"
                    className="form-control"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                  />
                </div>


                {/* TOTAL PURCHASE */}
                <div className="mb-3">
                  <label className="form-label fw-semibold mb-1">
                    Total Purchase :
                  </label>

                  <div className="form-control bg-light">
                    {formData.total_pur || 0}
                  </div>
                </div>


                {/* OPENING BALANCE */}
                <div className="mb-3">
                  <label className="form-label fw-semibold mb-1">
                    Opening Bal :
                  </label>

                  <input
                    type="number"
                    className="form-control"
                    name="opening_balance"
                    value={formData.opening_balance}
                    onChange={handleInputChange}
                    disabled={isEditMode}
                  />
                </div>

              </div>


              {/* =========================
                  RIGHT SECTION
              ========================== */}
              <div className="col-12 col-md-6">

                {/* GST TYPE */}
                <div className="mb-3">
                  <label className="form-label fw-semibold mb-1">
                    GSTIN Type :
                  </label>

                  <select
                    className="form-select"
                    name="gst_type"
                    value={formData.gst_type}
                    onChange={handleInputChange}
                  >
                    <option value="">
                      Select
                    </option>

                    <option value="Registered">
                      Registered
                    </option>

                    <option value="Unregistered">
                      Unregistered
                    </option>
                  </select>
                </div>


                {/* GST STATE */}
                <div className="mb-3">
                  <label className="form-label fw-semibold mb-1">
                    GSTIN State :
                  </label>

                  <input
                    type="text"
                    className="form-control"
                    name="gst_state"
                    value={formData.gst_state}
                    onChange={handleInputChange}
                    disabled={formData.gst_type === "Unregistered"}
                  />
                </div>


                {/* GST ADDRESS */}
                <div className="mb-3">
                  <label className="form-label fw-semibold mb-1">
                    GSTIN Address :
                  </label>

                  <textarea
                    className="form-control"
                    name="address"
                    value={formData.address}
                    onChange={handleInputChange}
                    rows="3"
                    disabled={formData.gst_type === "Unregistered"}
                  />
                </div>


                {/* TOTAL DUE - EDIT MODE */}
                {isEditMode && (
                  <div className="mb-3">
                    <label className="form-label fw-semibold text-danger mb-1">
                      Total Due :
                    </label>

                    <input
                      type="number"
                      className="form-control bg-light text-danger fw-semibold"
                      name="total_due"
                      value={formData.total_due || 0}
                      disabled
                    />
                  </div>
                )}


                {/* AS OF DATE - ADD MODE ONLY */}
                {!isEditMode && (
                  <div className="mb-3">
                    <label className="form-label fw-semibold mb-1">
                      As Of Date :
                    </label>

                    <input
                      type="datetime-local"
                      className="form-control"
                      name="asOfDate"
                      value={formData.asOfDate}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                )}

              </div>

            </div>

          </div>


          {/* =========================
              FOOTER
          ========================== */}
          <div className="border-top px-4 py-3">

            <div className="row align-items-center justify-content-between">

              {/* CLOSE */}
              <div className="col-auto">
                <button
                  type="button"
                  className="btn btn-secondary px-4"
                  onClick={() => {
                    setShowPartyForm(false);
                  
                    resetForm();
                  }}
                >
                  Close
                </button>
              </div>


              {/* SUBMIT / UPDATE */}
              <div className="col-auto">
                <button
                  type="submit"
                  className="btn btn-primary px-4"
                >
                  {isEditMode
                    ? "Update Details"
                    : "Submit Details"}
                </button>
              </div>

            </div>

          </div>

        </div>
      </div>
    </form>
  </div>
)}
    </div>
  )
}

export default AddSale
